import { Box, Button, Checkbox, FormControlLabel, Typography } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { CardElement, PaymentRequestButtonElement } from 'react-stripe-elements';
import { formatCurrency, Loader, track } from '../../libs/helpers';
import { AppConfig } from '../../../../config/app';


class FundraiseSeedPersonal extends React.Component {

  state = {
    paymentRequest: null,
  }
  /*
  -----------------------------------------------------------------------
  API Functions
  -----------------------------------------------------------------------
  */

  /*
  -----------------------------------------------------------------------
  RENDER Functions
  -----------------------------------------------------------------------
  */
  onChange = (fieldName) => (e) => {
    this.props.onChange(fieldName, e.target.value)
  }
  onChangeAnonymous = (e) => {
    track(
      this.props.trackPageCode,
      'Anonymous ' + (!this.props.form.anonymous ? 'Checked' : 'Not Checked'));
    this.props.onChange('anonymous', !this.props.form.anonymous)
  }
  componentDidUpdate(prevProps) {
    if (this.props.form.processedAmount &&
      (
        prevProps.form.processedAmount !== this.props.form.processedAmount
        || prevProps.form.monthly !== this.props.form.monthly
      )) {
      //Apple and Google Pay Support
      const total = {
        label: 'Donate' + (this.props.form.monthly ? ' Monthly' : '') + ' to ' + this.props.fundraise.name,
        amount: Math.round(this.props.form.processedAmount * 100),
      };
      if (this.state.paymentRequest) {
        this.state.paymentRequest.update({ total });
      } else {
        //Init 
        const paymentRequest = this.props.stripe.paymentRequest({
          country: 'US',
          currency: 'usd',
          total: total,
          requestPayerName: true,
          requestPayerEmail: true,
          //wallets: AppConfig.stripeSupportedWallets,
        });
        // Check the availability of the Payment Request API.
        paymentRequest.canMakePayment().then((result) => {
          paymentRequest.on('paymentmethod', async (data) => {
            data.complete('success'/* res ? 'success' : 'fail' */);
            const res = await this.props.performSeedAction(data.paymentMethod, data.payerName, data.payerEmail);
          });
          paymentRequest.on('cancel', async () => {
            track(this.props.trackPageCode, 'Express Donation Cancelled');
          });
          if (result)
            this.setState({ paymentRequest });
        });
      }
    }
  }
  onCardChange = async (obj) => {
    if (obj.complete)
      track(this.props.trackPageCode, 'Card Filled', obj.brand);
    if (obj.elementType === 'card' && obj.brand !== this.state.cardBrand) {
      await this.props.onChangeRoot({ cardBrand: obj.brand, cardComplete: obj.complete });
    } else {
      this.props.onChangeRoot({ cardComplete: obj.complete });
    }
  }
  onExpressDonationClicked = () => {
    track(this.props.trackPageCode, 'Express Donation Clicked');
  }
  /* Render Page */
  render() {
    const { match, form, onFieldBlur, classes, loading } = this.props;
    const { paymentRequest } = this.state;
    return (
      <div >
        {paymentRequest &&
          <div>
            <PaymentRequestButtonElement
              onClick={this.onExpressDonationClicked}
              paymentRequest={paymentRequest}
              style={{
                paymentRequestButton: { height: '60px', type: 'donate', },
              }}
            />
            <Box marginBottom={0} marginTop={2} >
              <Typography align="center" className={classes.enterDetailsText} color="textSecondary">
                <span>or enter your details manually below</span>
              </Typography>
            </Box>
          </div>}
        <div>
          {!match.params.email && <TextField
            id="donorEmail"
            label="Your email"
            value={form.donorEmail}
            margin="normal"
            variant="outlined"
            onChange={this.onChange('donorEmail')}
            name='donorEmail'
            type='email'
            fullWidth
            InputProps={{ classes: { notchedOutline: classes.dedicationFields, } }}
            inputProps={{ className: 'padding-input' }}
            InputLabelProps={{ className: 'padding-label' }}
            onBlur={onFieldBlur('Donor Email')}
          />}
          <TextField
            id="donorAlias"
            label="Your name"
            value={form.donorAlias}
            margin="normal"
            variant="outlined"
            onChange={this.onChange('donorAlias')}
            name='donorAlias'
            fullWidth
            inputProps={{ className: 'padding-input' }}
            InputProps={{ classes: { notchedOutline: classes.dedicationFields, } }}
            InputLabelProps={{ className: 'padding-label' }}
            onBlur={onFieldBlur('Donor Name')}
          />
          <FormControlLabel
            className={classes.anonymous}
            control={
              <Checkbox
                checked={form.anonymous}
                value="1"
                name='anonymous'
                color="primary"
                className='tbpadding-5'
                onChange={this.onChangeAnonymous}

              />
            }
            label="Hide my name, show anonymous instead."
          />
          <div className={classes.cardWrapper} >
            <div className='  card-field'  >
              <CardElement onChange={this.onCardChange} />
            </div>
          </div>
        </div>
        <Typography align="right" color="textSecondary" className={classes.totalAmountText}>
          Total Amount: <Typography className={classes.totalAmount} display="inline">${formatCurrency(form.processedAmount, 2)}</Typography>
        </Typography>
        <Button fullWidth variant='contained' className={[classes.buttonAlt]} disabled={loading} onClick={this.props.onPanelExpanded('chooseAmount')}>Back</Button>
        {/* <Button fullWidth variant='contained' className={[classes.button]} onClick={this.props.onPanelExpanded('checkout')}>Next Step</Button> */}
        <Button fullWidth variant='contained' className={[classes.button]} onClick={() => this.props.performSeedAction()} disabled={loading}>{loading ? <Loader color='#fff' /> : 'Confirm' + (form.monthly ? ' Monthly Donation':'')}</Button>

      </div>
    );
  }
}

export default withRouter(FundraiseSeedPersonal);